import {combineReducers, Reducer} from 'redux';
import {MenuState} from '@models/menu'
import {MenusActionTypes} from '@actions/menu';


// Type-safe initialState!
export const initialState: MenuState = {
    allIds: [],
    byId: {},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case MenusActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return {
                ...data.reduce((obj, menu) => {
                    obj[menu.id] = {
                        ...menu,
                        is_fetched: false,
                        ...(state[menu.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case MenusActionTypes.CREATE_SUCCESS: {
            const menu = action.payload;
            return {
                ...state,
                [menu.id]: menu
            };
        }

        case MenusActionTypes.UPDATE_SUCCESS: {
            const menu = action.payload;
            return {
                ...state,
                [menu.id]: {
                    ...state[menu.id],
                    ...menu
                }
            };
        }

        case MenusActionTypes.FETCH_ITEM_SUCCESS: {
            const menu = action.payload;
            return {
                ...state,
                [menu.id]: {
                    ...state[menu.id],
                    ...menu,
                    is_fetched: true
                },
            };
        }

        case MenusActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case MenusActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map(item => item.id);
        }

        case MenusActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case MenusActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case MenusActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case MenusActionTypes.DELETE_SUCCESS:
            return state - 1;

        case MenusActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case MenusActionTypes.FETCH_REQUEST:
            {
            return true;
        }

        case MenusActionTypes.FETCH_SUCCESS:
        case MenusActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<MenuState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export {reducer as menuReducer}


//Selectors
export const getMenusList = menus => menus.allIds.map(id => menus.byId[id]);

export const getMenuById = (menus, id) => menus.byId[id];